<template>
  <div>
    <section id="knowledge-base-search" class="mb-4">
      <h2 class="mb-1">Onboarding Checklist</h2>
      <b-list-group>
        <b-list-group-item
          v-for="(item, index) in checklistItems"
          :key="index"
          class="d-flex align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <!-- <b-form-checkbox class="mr-2" v-model="item.checked">
              <span class="d-flex align-items-center">

                <span :class="{ 'text-muted text-decoration-line-through': item.checked }">
                  <strong>{{ item.title }}</strong> {{ item.text }}
                </span>
              </span>
            </b-form-checkbox> -->

            <span
              :class="{
                'text-muted text-decoration-line-through': item.checked,
              }"
            >
              <strong>{{ item.title }}</strong> {{ item.text }}
            </span>
          </div>
          <b-button
            size="sm"
            variant="primary"
            @click="item.url ? openUrl(item.url) : goToTab(item.activeTab)"
            >Go</b-button
          >
        </b-list-group-item>
      </b-list-group>
    </section>
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BButton,
  BRow,
  BCol,
  BImg,
  BCardBody,
  BCardTitle,
  BCardSubTitle,
  BLink,
  BCarousel,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BFormTextarea,
  BCarouselSlide,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";

import Ripple from "vue-ripple-directive";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";

export default {
  components: {
    BCard,
    BCardText,
    BButton,
    BCardBody,
    BCardTitle,
    BCardText,
    BCardSubTitle,
    BRow,
    BCol,
    BLink,
    BImg,
    BCarousel,
    BCarouselSlide,
    AppCollapse,
    AppCollapseItem,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BFormTextarea,
    BListGroup,
    BListGroupItem,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data: () => ({
    collapseType: "default",
  }),
  data() {
    return {
      checklistItems: [
        { text: "Set up Users", checked: false, url: "/role/users" },
        {
          text: "Set up VAT and BRN if any",
          checked: false,
          url: null,
          activeTab: "companySettings",
        },
        // { text: "Create your products", checked: false, url: "/product/list" },
      ],
    };
  },
  computed: {
    filteredKB() {
      // Implement your filtering logic here if necessary
      return this.knowledgeBase;
    },
  },
  methods: {
    async openUrl(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    scrollToContact() {
      // Scroll to the contact section
      this.$refs.contactSection.scrollIntoView({ behavior: "smooth" });
    },
    goToTab(activeTab) {
      this.$emit("goToTab", activeTab);
    },
  },
};
</script>

<style scoped>
.card-overlay {
  position: relative;
  overflow: hidden;
}

.card-overlay .card-img-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(173, 173, 173, 0.13);
  /* Overlay color */
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.card-overlay:hover .card-img-overlay {
  opacity: 1;
}

.card-overlay .card {
  transition: background-color 0.3s ease-in-out;
}

/* Coming Soon Card */
.coming-soon-card {
  position: relative;
}

.coming-soon-btn {
  background-color: rgba(165, 197, 76) !important;
  border: none;
  color: #fff;
  font-size: 1rem;
  border-radius: 0.25rem;
  /* Centering adjustments */
  margin: auto;
}

.coming-soon-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  /* Horizontally center */
  align-items: center;
  /* Vertically center */
  background-color: rgba(225, 225, 225, 0.171);
  border-radius: 8px;
}
</style>